import { Card, Row, Col, Select } from "antd";
import { EXOSCALE_ZONES } from "../enums/enums";
import { useEffect, useState } from "react";
import CloudIcon from "./CloudIcon";

interface ChooseExoscaleAccountCardProps {
    classNames?: string;
    selectedAccount?: {
        exoscaleAccountId?: string;
        exoscaleZone?: string;
    };
    exoscaleAccounts: { id: string, name: string }[];
    onSelect?: ({ exoscaleAccountId, exoscaleZone }: { exoscaleAccountId: string; exoscaleZone: string; }) => void;
}
const ChooseExoscaleAccountCard = ({
    onSelect,
    selectedAccount,
    classNames,
    exoscaleAccounts
}: ChooseExoscaleAccountCardProps) => {
    // this component re-renders every time the selectedAccount is changed because it propagates back the change
    // and expects the same parametar as an input prop, so this is a solution to always have items in the list that is used
    // for the dropdown menu, because otherwise it will flicker
    const [exoscaleAccountsSelectItems, setExoscaleAccountSelectItems] = useState(
        selectedAccount?.exoscaleAccountId || selectedAccount?.exoscaleZone ?
            [{
                id: selectedAccount?.exoscaleAccountId,
                name: selectedAccount?.exoscaleAccountId
            }] :
            []
    );

    useEffect(() => {
        setExoscaleAccountSelectItems(exoscaleAccounts);
    }, [exoscaleAccounts])

    const handleOnSelectAccount = (exoscaleAccountId: string) => {
        onSelect?.({
            exoscaleAccountId,
            exoscaleZone: selectedAccount?.exoscaleZone!
        });
    }

    const handleOnSelectZone = (exoscaleZone: string) => {
        onSelect?.({
            exoscaleAccountId: selectedAccount?.exoscaleAccountId!,
            exoscaleZone
        });
    }

    return (
        <Card type="inner" className={classNames} >
            <Card.Meta
                title="Link Exoscale account"
                description="The components and apps will be deployed in the selected account and zone."
            />
            <br />
            {
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            placeholder="Select Exoscale account"
                            value={selectedAccount?.exoscaleAccountId}
                            onSelect={handleOnSelectAccount}
                        >
                            {
                                exoscaleAccountsSelectItems.map(acc => (
                                    <Select.Option value={acc.id} key={acc.id}>
                                        <CloudIcon provider="exoscale" /> {acc.name}
                                    </Select.Option>
                                ))
                            }
                        </Select>
                    </Col>
                    <Col span={24}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            placeholder="Select zone"
                            filterOption={(input, option: any) => {
                                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            filterSort={(optionA, optionB) => {
                                return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }}
                            value={selectedAccount?.exoscaleZone}
                            onSelect={handleOnSelectZone}
                        >
                            {
                                EXOSCALE_ZONES.map(zone => (
                                    <Select.Option value={zone.id} key={zone.id}>
                                        {zone.name}
                                    </Select.Option>
                                ))
                            }
                        </Select>
                    </Col>
                </Row>
            }
        </Card >
    );
}

export default ChooseExoscaleAccountCard;

